export const FixedAttachmentQcFieldName = 'fixedAttachmentQcFieldComponent';
